import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../../view/components/ProtectedRoute/ProtectedRoute';
import Landing from '../../view/pages/Landing/Landing';
import Login from '../../view/pages/Login/Login';
import Schedule from '../../view/pages/Schedule/Schedule';
import Specialties from '../../view/pages/Specialties/Specialties';
import MedicalCenterDoctors from '../../view/pages/MedicalCenterDoctors/MedicalCenterDoctors';
import ChoosePatient from '../../view/pages/ChoosePatient/ChoosePatient';
import DoctorScheduler from '../../view/pages/DoctorScheduler/DoctorScheduler';
import MedicalAppointmentList from '../../view/pages/MedicalAppointList/MedicalAppointmentList';
import Patients from '../../view/pages/Patients/Patients';
import { SetPatient } from '../../view/pages/SetPatient/SetPatient';
import MedicalAppointment from '../../view/pages/MedicalAppointment/MedicalAppointment';
import Register from '../../view/pages/Register/Register';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route
          path='*'
          element={
            <ProtectedRoute>
              <Landing />
            </ProtectedRoute>
          }
        />
        <Route
          path='/citas'
          element={
            <ProtectedRoute>
              <Schedule />
            </ProtectedRoute>
          }
        />
        <Route
          path='/citas/especialidades'
          element={
            <ProtectedRoute>
              <Specialties />
            </ProtectedRoute>
          }
        />
        <Route
          path='/citas/especialidades/centros'
          element={
            <ProtectedRoute>
              <MedicalCenterDoctors />
            </ProtectedRoute>
          }
        />
        <Route
          path='/citas/especialidades/centros/crear'
          element={
            <ProtectedRoute>
              <ChoosePatient />
            </ProtectedRoute>
          }
        />
        <Route
          path='/doctores'
          element={
            <ProtectedRoute>
              <DoctorScheduler />
            </ProtectedRoute>
          }
        />
        <Route
          path='/consultas'
          element={
            <ProtectedRoute onlyDoctor>
              <MedicalAppointmentList />
            </ProtectedRoute>
          }
        />
        <Route
          path='/consultas/:id'
          element={
            <ProtectedRoute>
              <MedicalAppointment />
            </ProtectedRoute>
          }
        />
        <Route
          path='/pacientes'
          element={
            <ProtectedRoute>
              <Patients />
            </ProtectedRoute>
          }
        />
        <Route
          path='/pacientes/crear'
          element={
            <ProtectedRoute>
              <SetPatient />
            </ProtectedRoute>
          }
        />
        <Route
          path='/pacientes/:id'
          element={
            <ProtectedRoute>
              <SetPatient />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
